import { LoadingAnimation } from '@uag/react-core';
import { useGetRemarks } from '@uag/welcome-shared/src/api/queries/remarks/remarks';
import { useTranslation } from 'react-i18next';

import { useRequestContext } from './RequestProvider';

export const Remarks = () => {
    const { request } = useRequestContext();

    const { data: remarks, isLoading } = useGetRemarks(request.id);
    const { t } = useTranslation();

    if (!remarks || !remarks.data || remarks.data.length === 0) {
        return null;
    }

    if (isLoading) {
        return <LoadingAnimation />;
    }

    return (
        <div>
            <div>{t('remarks')}</div>
            <div className="border-border-disabled bg-background-gray-ultra-light border p-4 text-sm">
                {remarks.data.map((remark) => (
                    <div key={remark.id}>{remark.text}</div>
                ))}
            </div>
        </div>
    );
};
